import api from "@helpers/api";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/position/office`;

export const getDesignationsByUnit = async ({
  officeId,
  unitId,
}: {
  officeId: number;
  unitId: number;
}) => {
  const response = await api.get(`${apiEndPoint}/${officeId}/unit/${unitId}`);
  return response.data;
};
